import axios from "axios";
import { TypeMessage } from "../../Models/Message/MessageModels"
import { URL_MIDIS, URLAPI } from "../../Setting";
import { errorService } from "../Error/ErrorService";

export function TypeMessageService(){
    return {
        async getTypeMessageFromUrlToOptions(url:string|undefined, token:string){
            let typeMessage:TypeMessage = {
                id:0,
                type:'',
                optionsAbonnement:[],
                integration:''
            }
            try {
                const response = await axios.get(`${URL_MIDIS+url}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];

                typeMessage = {
                    id:data[0]['id'],
                    type:data[0]['type'],
                    optionsAbonnement:data[0]['optionsAbonnements'],
                    integration:data[0]['integration']
                }
                return typeMessage;
            } catch (error) {
                errorService().handleError('Erreur dans getTypeMessageFromUrl',error);
                return typeMessage;
            }
        },

        async getTypeMessage(id:number, token:string){
            let typeMessage:TypeMessage = {
                id:0,
                type:'',
                optionsAbonnement:[],
                integration:''
            }
            try {
                const response = await axios.get(`${URLAPI+'typeMessage/'+id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];

                typeMessage = {
                    id:data[0]['id'],
                    type:data[0]['type'],
                    optionsAbonnement:data[0]['optionsAbonnement'],
                    integration:data[0]['integration']
                }
                return typeMessage;
            } catch (error) {
                errorService().handleError('Erreur dans getTypeMessage',error);
                return typeMessage;
            }
        },

        async getTypesMessage(token:string){
            let typesMessages:TypeMessage[]=[];
            try {
                const response = await axios.get(`${URLAPI+'typesMessage'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                for(const element of data){
                    typesMessages.push({
                        '@id':element['@id'],
                        id:element['id'],
                        type:element['type'],
                        optionsAbonnement:element['optionsAbonnement'].map((opt:any)=>{return {'@id':opt}}),
                        integration:element['integration']
                    })
                }
            } catch (error) {
                errorService().handleError('Erreur dans getTypesMessage',error);
                return [];
            }
            return typesMessages;
        },

        /**
         * Version filtrée de l'obtention de tous les types de messages pour obtenir uniquement les données pour messages fixe ou habillage
         * @param token 
         * @returns 
         */
        async getTypeMessagesFixesHabillage(token:string){
            let typesMessages:TypeMessage[]=[];
            try {
                const response = await axios.get(`${URLAPI+'typesMessage'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];

                for(const element of data){
                    if(element['type']==='Fixe' || element['type']==='Habillage')
                        typesMessages.push({
                            '@id':element['@id'],
                            id:element['id'],
                            type:element['type'],
                            optionsAbonnement:element['optionsAbonnements'],
                            integration:element['integration']
                        })
                }
            } catch (error) {
                errorService().handleError('Erreur dans getTypesMessage',error);
                return [];
            }
            return typesMessages;
        }
    }
}